import * as React from "react";
import { memo } from "react";
import styled, { ThemeContext } from "styled-components";
import { themeGet } from "@styled-system/theme-get";
import { Text } from "pcln-design-system";
const IconWrapper = /*#__PURE__*/styled(Text).withConfig({
  displayName: "CarsOutline__IconWrapper",
  componentId: "sc-4myerx-0"
})(["display:inline-block;"]);
function BaseComponent({
  title,
  titleId,
  ...props
}) {
  const themeContext = React.useContext(ThemeContext);
  const themeProps = {
    theme: themeContext
  };
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    focusable: false,
    "aria-hidden": true,
    role: "img",
    "aria-labelledby": titleId,
    ...props
  }, title ? React.createElement("title", {
    id: titleId
  }, title) : null, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: themeGet("palette.primary.base")(themeProps),
    d: "M8 20.064c0 1.051-.971 1.863-2.158 1.931L5.679 22H5.32c-1.189 0-2.204-.746-2.312-1.77L3 20.09V18h-.502a1.5 1.5 0 0 1-.978-.407l-.11-.114a1.66 1.66 0 0 1-.406-.979l-.003-.153v-3.938c.026-.939.4-1.792.994-2.41H1.86a1.4 1.4 0 0 1-.941-.344 1.23 1.23 0 0 1-.412-.784L.5 8.741v-.35c0-.735.601-1.319 1.35-1.385L1.992 7h1.387l.178-.595.411-1.271q.114-.462.358-.895c.252-.421.622-.76 1.085-.981a3.2 3.2 0 0 1 1.235-.259l.203.007h10.312a3.25 3.25 0 0 1 1.491.261c.442.213.812.55 1.071.984.117.208.212.427.283.645l.442 1.52.174.583L22.008 7c.765 0 1.412.54 1.485 1.255l.007.136v.35c0 .349-.153.678-.419.914a1.4 1.4 0 0 1-.79.339l-.145.006h-.139c.541.564.9 1.327.979 2.178l.014.234v3.922c.012.422-.134.834-.408 1.145-.245.28-.576.46-.943.508l-.16.013H21v2.064c0 1.049-.958 1.863-2.13 1.931l-.162.005h-.416c-1.19 0-2.2-.768-2.286-1.794L16 20.064V18H8z"
  }), React.createElement("path", {
    fill: themeGet("palette.primary.light")(themeProps),
    d: "m19.774 10 .155.01c1.081.116 1.95 1.055 2.06 2.246l.011.172v3.919l-.004.109a.66.66 0 0 1-.155.364c-.08.09-.18.149-.286.17l-.08.01H2.512l-.074-.01a.53.53 0 0 1-.278-.17.66.66 0 0 1-.156-.358l-.004-.102v-3.771l.001-.174c.05-1.266.941-2.284 2.07-2.404L4.229 10zM18.5 11.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-13 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4M15 13H9l-.09.008a.5.5 0 0 0 0 .984L9 14h6l.09-.008a.5.5 0 0 0 0-.984zm7.008-5 .092.007c.206.03.358.163.392.317l.008.067v.35l-.01.058a.25.25 0 0 1-.073.108.4.4 0 0 1-.19.087L22.15 9h-.938l-.294-1zM3.081 8l-.293 1h-.934l-.079-.006a.4.4 0 0 1-.192-.087.25.25 0 0 1-.074-.108L1.5 8.742V8.39l.008-.067c.034-.154.186-.286.392-.317L1.992 8z"
  }), React.createElement("path", {
    fill: themeGet("palette.background.lightest")(themeProps),
    d: "M20 18v2.064l-.007.097c-.063.418-.526.783-1.14.833l-.145.006h-.416l-.144-.006-.14-.017c-.544-.09-.943-.43-1-.816L17 20.064V18zM7 18v2.064l-.007.097c-.065.416-.537.783-1.166.833L5.679 21H5.32l-.146-.006-.14-.016c-.553-.088-.959-.424-1.026-.804L4 20.078 4 18zm11.5-5.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2m-13 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2m11.916-8.498q.44.011.824.176c.244.118.466.321.619.575.078.14.145.295.197.457l.047.165.386 1.324.492 1.65.202.686-.187-.023-.19-.012H4.212l-.199.013-.195.024.203-.69.49-1.646.419-1.293.052-.184c.056-.177.125-.334.208-.483.146-.242.368-.445.633-.573.24-.1.51-.16.786-.167l.208.003 10.376.002z"
  })));
}
const CarsOutline = props => React.createElement(IconWrapper, {
  fontSize: props.size,
  lineHeight: props.size,
  verticalAlign: "middle",
  className: props.className
}, React.createElement(BaseComponent, null));
/** @public */
const Memo = memo(CarsOutline);
export default Memo;